// @generated by protobuf-ts 2.8.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/request_schema/v1/request_schema.proto" (package "c1.api.request_schema.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
import { FieldMask } from "../../../../google/protobuf/field_mask";
import { AppEntitlementRef } from "../../app/v1/app_refs";
import { Field } from "../../form/v1/form";
import { Struct } from "../../../../google/protobuf/struct";
import { Timestamp } from "../../../../google/protobuf/timestamp";
import { Form } from "../../form/v1/form";
/**
 * @generated from protobuf message c1.api.request_schema.v1.RequestSchema
 */
export interface RequestSchema {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: c1.api.form.v1.Form form = 8;
     */
    form?: Form;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 5;
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp deleted_at = 6;
     */
    deletedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp modified_at = 7;
     */
    modifiedAt?: Timestamp;
    /**
     * @generated from protobuf field: c1.api.request_schema.v1.JustificationVisibility justification_visibility = 9;
     */
    justificationVisibility: JustificationVisibility;
}
/**
 * @generated from protobuf message c1.api.request_schema.v1.RequestSchemaRef
 */
export interface RequestSchemaRef {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
/**
 * @deprecated
 * @generated from protobuf message c1.api.request_schema.v1.RequestSchemaInstance
 */
export interface RequestSchemaInstance {
    /**
     * @generated from protobuf field: c1.api.request_schema.v1.RequestSchema request_schema = 1;
     */
    requestSchema?: RequestSchema;
    /**
     * @generated from protobuf field: google.protobuf.Struct data = 2;
     */
    data?: Struct;
}
/**
 * @generated from protobuf message c1.api.request_schema.v1.RequestSchemaEntitlementBinding
 */
export interface RequestSchemaEntitlementBinding {
    /**
     * @generated from protobuf field: string request_schema_id = 1;
     */
    requestSchemaId: string;
    /**
     * @generated from protobuf field: string app_id = 2;
     */
    appId: string;
    /**
     * @generated from protobuf field: string entitlement_id = 3;
     */
    entitlementId: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 4;
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp deleted_at = 5;
     */
    deletedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 6;
     */
    updatedAt?: Timestamp;
}
/**
 * @generated from protobuf message c1.api.request_schema.v1.RequestSchemaWithBinding
 */
export interface RequestSchemaWithBinding {
    /**
     * @generated from protobuf field: c1.api.request_schema.v1.RequestSchema request_schema = 1;
     */
    requestSchema?: RequestSchema;
    /**
     * @generated from protobuf field: c1.api.request_schema.v1.RequestSchemaEntitlementBinding binding = 2;
     */
    binding?: RequestSchemaEntitlementBinding;
}
/**
 * @generated from protobuf message c1.api.request_schema.v1.RequestSchemaServiceCreateRequest
 */
export interface RequestSchemaServiceCreateRequest {
    /**
     * @generated from protobuf field: string name = 1;
     */
    name: string;
    /**
     * @generated from protobuf field: string description = 2;
     */
    description: string;
    /**
     * @generated from protobuf field: repeated c1.api.form.v1.Field fields = 3;
     */
    fields: Field[];
}
/**
 * @generated from protobuf message c1.api.request_schema.v1.RequestSchemaServiceCreateResponse
 */
export interface RequestSchemaServiceCreateResponse {
    /**
     * @generated from protobuf field: c1.api.request_schema.v1.RequestSchema request_schema = 1;
     */
    requestSchema?: RequestSchema;
}
/**
 * @generated from protobuf message c1.api.request_schema.v1.RequestSchemaServiceDeleteRequest
 */
export interface RequestSchemaServiceDeleteRequest {
    /**
     * @generated from protobuf field: string request_schema_id = 1;
     */
    requestSchemaId: string;
}
/**
 * @generated from protobuf message c1.api.request_schema.v1.RequestSchemaServiceDeleteResponse
 */
export interface RequestSchemaServiceDeleteResponse {
}
/**
 * @generated from protobuf message c1.api.request_schema.v1.RequestSchemaServiceGetRequest
 */
export interface RequestSchemaServiceGetRequest {
    /**
     * @generated from protobuf field: string request_schema_id = 1;
     */
    requestSchemaId: string;
}
/**
 * @generated from protobuf message c1.api.request_schema.v1.RequestSchemaServiceGetResponse
 */
export interface RequestSchemaServiceGetResponse {
    /**
     * @generated from protobuf field: c1.api.request_schema.v1.RequestSchema request_schema = 1;
     */
    requestSchema?: RequestSchema;
}
/**
 * @generated from protobuf message c1.api.request_schema.v1.RequestSchemaServiceFindByAppEntitlementRequest
 */
export interface RequestSchemaServiceFindByAppEntitlementRequest {
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementRef entitlement_ref = 1;
     */
    entitlementRef?: AppEntitlementRef;
}
/**
 * @generated from protobuf message c1.api.request_schema.v1.RequestSchemaServiceFindByAppEntitlementResponse
 */
export interface RequestSchemaServiceFindByAppEntitlementResponse {
    /**
     * @generated from protobuf field: c1.api.request_schema.v1.RequestSchema request_schema = 1;
     */
    requestSchema?: RequestSchema;
}
/**
 * @generated from protobuf message c1.api.request_schema.v1.RequestSchemaServiceListRequest
 */
export interface RequestSchemaServiceListRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: repeated c1.api.request_schema.v1.RequestSchemaRef refs = 3;
     */
    refs: RequestSchemaRef[];
}
/**
 * @generated from protobuf message c1.api.request_schema.v1.RequestSchemaServiceListResponse
 */
export interface RequestSchemaServiceListResponse {
    /**
     * @generated from protobuf field: repeated c1.api.request_schema.v1.RequestSchema list = 1;
     */
    list: RequestSchema[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.request_schema.v1.RequestSchemaServiceUpdateRequest
 */
export interface RequestSchemaServiceUpdateRequest {
    /**
     * @generated from protobuf field: c1.api.request_schema.v1.RequestSchema request_schema = 1;
     */
    requestSchema?: RequestSchema;
    /**
     * @generated from protobuf field: google.protobuf.FieldMask update_mask = 2;
     */
    updateMask?: FieldMask;
}
/**
 * @generated from protobuf message c1.api.request_schema.v1.RequestSchemaServiceUpdateResponse
 */
export interface RequestSchemaServiceUpdateResponse {
    /**
     * @generated from protobuf field: c1.api.request_schema.v1.RequestSchema request_schema = 1;
     */
    requestSchema?: RequestSchema;
}
/**
 * @generated from protobuf message c1.api.request_schema.v1.RequestSchemaServiceCreateEntitlementBindingsRequest
 */
export interface RequestSchemaServiceCreateEntitlementBindingsRequest {
    /**
     * @generated from protobuf field: string request_schema_id = 1;
     */
    requestSchemaId: string;
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementRef entitlement_refs = 2;
     */
    entitlementRefs: AppEntitlementRef[];
}
/**
 * @generated from protobuf message c1.api.request_schema.v1.RequestSchemaServiceCreateEntitlementBindingsResponse
 */
export interface RequestSchemaServiceCreateEntitlementBindingsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.request_schema.v1.RequestSchemaEntitlementBinding entitlement_bindings = 1;
     */
    entitlementBindings: RequestSchemaEntitlementBinding[];
}
/**
 * @generated from protobuf message c1.api.request_schema.v1.RequestSchemaServiceRemoveEntitlementBindingsRequest
 */
export interface RequestSchemaServiceRemoveEntitlementBindingsRequest {
    /**
     * @generated from protobuf field: string request_schema_id = 1;
     */
    requestSchemaId: string;
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementRef entitlement_refs = 2;
     */
    entitlementRefs: AppEntitlementRef[];
}
/**
 * @generated from protobuf message c1.api.request_schema.v1.RequestSchemaServiceRemoveEntitlementBindingsResponse
 */
export interface RequestSchemaServiceRemoveEntitlementBindingsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.request_schema.v1.RequestSchemaEntitlementBinding entitlement_bindings = 1;
     */
    entitlementBindings: RequestSchemaEntitlementBinding[];
}
/**
 * @generated from protobuf message c1.api.request_schema.v1.RequestSchemaServiceCreateEntitlementBindingRequest
 */
export interface RequestSchemaServiceCreateEntitlementBindingRequest {
    /**
     * @generated from protobuf field: string request_schema_id = 1;
     */
    requestSchemaId: string;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementRef entitlement_ref = 2;
     */
    entitlementRef?: AppEntitlementRef;
}
/**
 * @generated from protobuf message c1.api.request_schema.v1.RequestSchemaServiceCreateEntitlementBindingResponse
 */
export interface RequestSchemaServiceCreateEntitlementBindingResponse {
    /**
     * @generated from protobuf field: string request_schema_id = 1;
     */
    requestSchemaId: string;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementRef entitlement_ref = 2;
     */
    entitlementRef?: AppEntitlementRef;
}
/**
 * @generated from protobuf message c1.api.request_schema.v1.RequestSchemaServiceRemoveEntitlementBindingRequest
 */
export interface RequestSchemaServiceRemoveEntitlementBindingRequest {
    /**
     * @generated from protobuf field: string request_schema_id = 1;
     */
    requestSchemaId: string;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementRef entitlement_ref = 2;
     */
    entitlementRef?: AppEntitlementRef;
}
/**
 * @generated from protobuf message c1.api.request_schema.v1.RequestSchemaServiceRemoveEntitlementBindingResponse
 */
export interface RequestSchemaServiceRemoveEntitlementBindingResponse {
}
/**
 * @generated from protobuf message c1.api.request_schema.v1.RequestSchemaServiceFindBindingForAppEntitlementRequest
 */
export interface RequestSchemaServiceFindBindingForAppEntitlementRequest {
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementRef entitlement_ref = 1;
     */
    entitlementRef?: AppEntitlementRef;
}
/**
 * @generated from protobuf message c1.api.request_schema.v1.RequestSchemaServiceFindBindingForAppEntitlementResponse
 */
export interface RequestSchemaServiceFindBindingForAppEntitlementResponse {
    /**
     * @generated from protobuf field: string request_schema_id = 1;
     */
    requestSchemaId: string;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementRef entitlement_ref = 2;
     */
    entitlementRef?: AppEntitlementRef;
}
/**
 * @generated from protobuf message c1.api.request_schema.v1.RequestSchemaServiceUpdateBindingsRequest
 */
export interface RequestSchemaServiceUpdateBindingsRequest {
    /**
     * @generated from protobuf field: string request_schema_id = 1;
     */
    requestSchemaId: string;
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementRef entitlement_refs = 2;
     */
    entitlementRefs: AppEntitlementRef[];
}
/**
 * @generated from protobuf message c1.api.request_schema.v1.RequestSchemaServiceUpdateBindingsResponse
 */
export interface RequestSchemaServiceUpdateBindingsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.request_schema.v1.RequestSchemaEntitlementBinding request_schema_entitlement_bindings = 1;
     */
    requestSchemaEntitlementBindings: RequestSchemaEntitlementBinding[];
}
/**
 * @generated from protobuf message c1.api.request_schema.v1.RequestSchemaServiceFindForAppEntitlementsRequest
 */
export interface RequestSchemaServiceFindForAppEntitlementsRequest {
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementRef entitlement_refs = 1;
     */
    entitlementRefs: AppEntitlementRef[];
}
/**
 * @generated from protobuf message c1.api.request_schema.v1.RequestSchemaServiceFindForAppEntitlementsResponse
 */
export interface RequestSchemaServiceFindForAppEntitlementsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.request_schema.v1.RequestSchemaWithBinding request_schemas_entitlement_with_bindings = 1;
     */
    requestSchemasEntitlementWithBindings: RequestSchemaWithBinding[];
}
/**
 * @generated from protobuf message c1.api.request_schema.v1.RequestSchemaServiceCountBindingsForSchemaRequest
 */
export interface RequestSchemaServiceCountBindingsForSchemaRequest {
    /**
     * @generated from protobuf field: string request_schema_id = 1;
     */
    requestSchemaId: string;
}
/**
 * @generated from protobuf message c1.api.request_schema.v1.RequestSchemaServiceCountBindingsForSchemaResponse
 */
export interface RequestSchemaServiceCountBindingsForSchemaResponse {
    /**
     * @generated from protobuf field: int64 num_bindings = 1;
     */
    numBindings: number;
}
/**
 * @generated from protobuf message c1.api.request_schema.v1.RequestSchemaServiceSearchRequest
 */
export interface RequestSchemaServiceSearchRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: string query = 3;
     */
    query: string;
}
/**
 * @generated from protobuf message c1.api.request_schema.v1.RequestSchemaServiceSearchResponse
 */
export interface RequestSchemaServiceSearchResponse {
    /**
     * @generated from protobuf field: repeated c1.api.request_schema.v1.RequestSchema list = 1;
     */
    list: RequestSchema[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf enum c1.api.request_schema.v1.JustificationVisibility
 */
export enum JustificationVisibility {
    /**
     * @generated from protobuf enum value: JUSTIFICATION_VISIBILITY_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: JUSTIFICATION_VISIBILITY_SHOW = 1;
     */
    SHOW = 1,
    /**
     * @generated from protobuf enum value: JUSTIFICATION_VISIBILITY_HIDE = 2;
     */
    HIDE = 2
}
// @generated message type with reflection information, may provide speed optimized methods
class RequestSchema$Type extends MessageType<RequestSchema> {
    constructor() {
        super("c1.api.request_schema.v1.RequestSchema", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "form", kind: "message", T: () => Form },
            { no: 5, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 6, name: "deleted_at", kind: "message", T: () => Timestamp },
            { no: 7, name: "modified_at", kind: "message", T: () => Timestamp },
            { no: 9, name: "justification_visibility", kind: "enum", T: () => ["c1.api.request_schema.v1.JustificationVisibility", JustificationVisibility, "JUSTIFICATION_VISIBILITY_"] }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.request_schema.v1.RequestSchema
 */
export const RequestSchema = new RequestSchema$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestSchemaRef$Type extends MessageType<RequestSchemaRef> {
    constructor() {
        super("c1.api.request_schema.v1.RequestSchemaRef", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.request_schema.v1.RequestSchemaRef
 */
export const RequestSchemaRef = new RequestSchemaRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestSchemaInstance$Type extends MessageType<RequestSchemaInstance> {
    constructor() {
        super("c1.api.request_schema.v1.RequestSchemaInstance", [
            { no: 1, name: "request_schema", kind: "message", T: () => RequestSchema },
            { no: 2, name: "data", kind: "message", T: () => Struct }
        ]);
    }
}
/**
 * @deprecated
 * @generated MessageType for protobuf message c1.api.request_schema.v1.RequestSchemaInstance
 */
export const RequestSchemaInstance = new RequestSchemaInstance$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestSchemaEntitlementBinding$Type extends MessageType<RequestSchemaEntitlementBinding> {
    constructor() {
        super("c1.api.request_schema.v1.RequestSchemaEntitlementBinding", [
            { no: 1, name: "request_schema_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 5, name: "deleted_at", kind: "message", T: () => Timestamp },
            { no: 6, name: "updated_at", kind: "message", T: () => Timestamp }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.request_schema.v1.RequestSchemaEntitlementBinding
 */
export const RequestSchemaEntitlementBinding = new RequestSchemaEntitlementBinding$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestSchemaWithBinding$Type extends MessageType<RequestSchemaWithBinding> {
    constructor() {
        super("c1.api.request_schema.v1.RequestSchemaWithBinding", [
            { no: 1, name: "request_schema", kind: "message", T: () => RequestSchema },
            { no: 2, name: "binding", kind: "message", T: () => RequestSchemaEntitlementBinding }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.request_schema.v1.RequestSchemaWithBinding
 */
export const RequestSchemaWithBinding = new RequestSchemaWithBinding$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestSchemaServiceCreateRequest$Type extends MessageType<RequestSchemaServiceCreateRequest> {
    constructor() {
        super("c1.api.request_schema.v1.RequestSchemaServiceCreateRequest", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1", maxBytes: "255" } } } },
            { no: 2, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "fields", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Field, options: { "validate.rules": { repeated: { minItems: "1", maxItems: "50" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.request_schema.v1.RequestSchemaServiceCreateRequest
 */
export const RequestSchemaServiceCreateRequest = new RequestSchemaServiceCreateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestSchemaServiceCreateResponse$Type extends MessageType<RequestSchemaServiceCreateResponse> {
    constructor() {
        super("c1.api.request_schema.v1.RequestSchemaServiceCreateResponse", [
            { no: 1, name: "request_schema", kind: "message", T: () => RequestSchema }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.request_schema.v1.RequestSchemaServiceCreateResponse
 */
export const RequestSchemaServiceCreateResponse = new RequestSchemaServiceCreateResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestSchemaServiceDeleteRequest$Type extends MessageType<RequestSchemaServiceDeleteRequest> {
    constructor() {
        super("c1.api.request_schema.v1.RequestSchemaServiceDeleteRequest", [
            { no: 1, name: "request_schema_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.request_schema.v1.RequestSchemaServiceDeleteRequest
 */
export const RequestSchemaServiceDeleteRequest = new RequestSchemaServiceDeleteRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestSchemaServiceDeleteResponse$Type extends MessageType<RequestSchemaServiceDeleteResponse> {
    constructor() {
        super("c1.api.request_schema.v1.RequestSchemaServiceDeleteResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.request_schema.v1.RequestSchemaServiceDeleteResponse
 */
export const RequestSchemaServiceDeleteResponse = new RequestSchemaServiceDeleteResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestSchemaServiceGetRequest$Type extends MessageType<RequestSchemaServiceGetRequest> {
    constructor() {
        super("c1.api.request_schema.v1.RequestSchemaServiceGetRequest", [
            { no: 1, name: "request_schema_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.request_schema.v1.RequestSchemaServiceGetRequest
 */
export const RequestSchemaServiceGetRequest = new RequestSchemaServiceGetRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestSchemaServiceGetResponse$Type extends MessageType<RequestSchemaServiceGetResponse> {
    constructor() {
        super("c1.api.request_schema.v1.RequestSchemaServiceGetResponse", [
            { no: 1, name: "request_schema", kind: "message", T: () => RequestSchema }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.request_schema.v1.RequestSchemaServiceGetResponse
 */
export const RequestSchemaServiceGetResponse = new RequestSchemaServiceGetResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestSchemaServiceFindByAppEntitlementRequest$Type extends MessageType<RequestSchemaServiceFindByAppEntitlementRequest> {
    constructor() {
        super("c1.api.request_schema.v1.RequestSchemaServiceFindByAppEntitlementRequest", [
            { no: 1, name: "entitlement_ref", kind: "message", T: () => AppEntitlementRef }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.request_schema.v1.RequestSchemaServiceFindByAppEntitlementRequest
 */
export const RequestSchemaServiceFindByAppEntitlementRequest = new RequestSchemaServiceFindByAppEntitlementRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestSchemaServiceFindByAppEntitlementResponse$Type extends MessageType<RequestSchemaServiceFindByAppEntitlementResponse> {
    constructor() {
        super("c1.api.request_schema.v1.RequestSchemaServiceFindByAppEntitlementResponse", [
            { no: 1, name: "request_schema", kind: "message", T: () => RequestSchema }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.request_schema.v1.RequestSchemaServiceFindByAppEntitlementResponse
 */
export const RequestSchemaServiceFindByAppEntitlementResponse = new RequestSchemaServiceFindByAppEntitlementResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestSchemaServiceListRequest$Type extends MessageType<RequestSchemaServiceListRequest> {
    constructor() {
        super("c1.api.request_schema.v1.RequestSchemaServiceListRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => RequestSchemaRef }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.request_schema.v1.RequestSchemaServiceListRequest
 */
export const RequestSchemaServiceListRequest = new RequestSchemaServiceListRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestSchemaServiceListResponse$Type extends MessageType<RequestSchemaServiceListResponse> {
    constructor() {
        super("c1.api.request_schema.v1.RequestSchemaServiceListResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => RequestSchema },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.request_schema.v1.RequestSchemaServiceListResponse
 */
export const RequestSchemaServiceListResponse = new RequestSchemaServiceListResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestSchemaServiceUpdateRequest$Type extends MessageType<RequestSchemaServiceUpdateRequest> {
    constructor() {
        super("c1.api.request_schema.v1.RequestSchemaServiceUpdateRequest", [
            { no: 1, name: "request_schema", kind: "message", T: () => RequestSchema, options: { "validate.rules": { message: { skip: true } } } },
            { no: 2, name: "update_mask", kind: "message", T: () => FieldMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.request_schema.v1.RequestSchemaServiceUpdateRequest
 */
export const RequestSchemaServiceUpdateRequest = new RequestSchemaServiceUpdateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestSchemaServiceUpdateResponse$Type extends MessageType<RequestSchemaServiceUpdateResponse> {
    constructor() {
        super("c1.api.request_schema.v1.RequestSchemaServiceUpdateResponse", [
            { no: 1, name: "request_schema", kind: "message", T: () => RequestSchema }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.request_schema.v1.RequestSchemaServiceUpdateResponse
 */
export const RequestSchemaServiceUpdateResponse = new RequestSchemaServiceUpdateResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestSchemaServiceCreateEntitlementBindingsRequest$Type extends MessageType<RequestSchemaServiceCreateEntitlementBindingsRequest> {
    constructor() {
        super("c1.api.request_schema.v1.RequestSchemaServiceCreateEntitlementBindingsRequest", [
            { no: 1, name: "request_schema_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "entitlement_refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementRef, options: { "validate.rules": { repeated: { minItems: "1", maxItems: "25" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.request_schema.v1.RequestSchemaServiceCreateEntitlementBindingsRequest
 */
export const RequestSchemaServiceCreateEntitlementBindingsRequest = new RequestSchemaServiceCreateEntitlementBindingsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestSchemaServiceCreateEntitlementBindingsResponse$Type extends MessageType<RequestSchemaServiceCreateEntitlementBindingsResponse> {
    constructor() {
        super("c1.api.request_schema.v1.RequestSchemaServiceCreateEntitlementBindingsResponse", [
            { no: 1, name: "entitlement_bindings", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => RequestSchemaEntitlementBinding }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.request_schema.v1.RequestSchemaServiceCreateEntitlementBindingsResponse
 */
export const RequestSchemaServiceCreateEntitlementBindingsResponse = new RequestSchemaServiceCreateEntitlementBindingsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestSchemaServiceRemoveEntitlementBindingsRequest$Type extends MessageType<RequestSchemaServiceRemoveEntitlementBindingsRequest> {
    constructor() {
        super("c1.api.request_schema.v1.RequestSchemaServiceRemoveEntitlementBindingsRequest", [
            { no: 1, name: "request_schema_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "entitlement_refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementRef, options: { "validate.rules": { repeated: { minItems: "1", maxItems: "25" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.request_schema.v1.RequestSchemaServiceRemoveEntitlementBindingsRequest
 */
export const RequestSchemaServiceRemoveEntitlementBindingsRequest = new RequestSchemaServiceRemoveEntitlementBindingsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestSchemaServiceRemoveEntitlementBindingsResponse$Type extends MessageType<RequestSchemaServiceRemoveEntitlementBindingsResponse> {
    constructor() {
        super("c1.api.request_schema.v1.RequestSchemaServiceRemoveEntitlementBindingsResponse", [
            { no: 1, name: "entitlement_bindings", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => RequestSchemaEntitlementBinding, options: { "validate.rules": { repeated: { minItems: "1", maxItems: "25" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.request_schema.v1.RequestSchemaServiceRemoveEntitlementBindingsResponse
 */
export const RequestSchemaServiceRemoveEntitlementBindingsResponse = new RequestSchemaServiceRemoveEntitlementBindingsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestSchemaServiceCreateEntitlementBindingRequest$Type extends MessageType<RequestSchemaServiceCreateEntitlementBindingRequest> {
    constructor() {
        super("c1.api.request_schema.v1.RequestSchemaServiceCreateEntitlementBindingRequest", [
            { no: 1, name: "request_schema_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "entitlement_ref", kind: "message", T: () => AppEntitlementRef }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.request_schema.v1.RequestSchemaServiceCreateEntitlementBindingRequest
 */
export const RequestSchemaServiceCreateEntitlementBindingRequest = new RequestSchemaServiceCreateEntitlementBindingRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestSchemaServiceCreateEntitlementBindingResponse$Type extends MessageType<RequestSchemaServiceCreateEntitlementBindingResponse> {
    constructor() {
        super("c1.api.request_schema.v1.RequestSchemaServiceCreateEntitlementBindingResponse", [
            { no: 1, name: "request_schema_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "entitlement_ref", kind: "message", T: () => AppEntitlementRef }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.request_schema.v1.RequestSchemaServiceCreateEntitlementBindingResponse
 */
export const RequestSchemaServiceCreateEntitlementBindingResponse = new RequestSchemaServiceCreateEntitlementBindingResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestSchemaServiceRemoveEntitlementBindingRequest$Type extends MessageType<RequestSchemaServiceRemoveEntitlementBindingRequest> {
    constructor() {
        super("c1.api.request_schema.v1.RequestSchemaServiceRemoveEntitlementBindingRequest", [
            { no: 1, name: "request_schema_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "entitlement_ref", kind: "message", T: () => AppEntitlementRef }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.request_schema.v1.RequestSchemaServiceRemoveEntitlementBindingRequest
 */
export const RequestSchemaServiceRemoveEntitlementBindingRequest = new RequestSchemaServiceRemoveEntitlementBindingRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestSchemaServiceRemoveEntitlementBindingResponse$Type extends MessageType<RequestSchemaServiceRemoveEntitlementBindingResponse> {
    constructor() {
        super("c1.api.request_schema.v1.RequestSchemaServiceRemoveEntitlementBindingResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.request_schema.v1.RequestSchemaServiceRemoveEntitlementBindingResponse
 */
export const RequestSchemaServiceRemoveEntitlementBindingResponse = new RequestSchemaServiceRemoveEntitlementBindingResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestSchemaServiceFindBindingForAppEntitlementRequest$Type extends MessageType<RequestSchemaServiceFindBindingForAppEntitlementRequest> {
    constructor() {
        super("c1.api.request_schema.v1.RequestSchemaServiceFindBindingForAppEntitlementRequest", [
            { no: 1, name: "entitlement_ref", kind: "message", T: () => AppEntitlementRef }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.request_schema.v1.RequestSchemaServiceFindBindingForAppEntitlementRequest
 */
export const RequestSchemaServiceFindBindingForAppEntitlementRequest = new RequestSchemaServiceFindBindingForAppEntitlementRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestSchemaServiceFindBindingForAppEntitlementResponse$Type extends MessageType<RequestSchemaServiceFindBindingForAppEntitlementResponse> {
    constructor() {
        super("c1.api.request_schema.v1.RequestSchemaServiceFindBindingForAppEntitlementResponse", [
            { no: 1, name: "request_schema_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "entitlement_ref", kind: "message", T: () => AppEntitlementRef }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.request_schema.v1.RequestSchemaServiceFindBindingForAppEntitlementResponse
 */
export const RequestSchemaServiceFindBindingForAppEntitlementResponse = new RequestSchemaServiceFindBindingForAppEntitlementResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestSchemaServiceUpdateBindingsRequest$Type extends MessageType<RequestSchemaServiceUpdateBindingsRequest> {
    constructor() {
        super("c1.api.request_schema.v1.RequestSchemaServiceUpdateBindingsRequest", [
            { no: 1, name: "request_schema_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "entitlement_refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementRef, options: { "validate.rules": { repeated: { minItems: "1", maxItems: "25" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.request_schema.v1.RequestSchemaServiceUpdateBindingsRequest
 */
export const RequestSchemaServiceUpdateBindingsRequest = new RequestSchemaServiceUpdateBindingsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestSchemaServiceUpdateBindingsResponse$Type extends MessageType<RequestSchemaServiceUpdateBindingsResponse> {
    constructor() {
        super("c1.api.request_schema.v1.RequestSchemaServiceUpdateBindingsResponse", [
            { no: 1, name: "request_schema_entitlement_bindings", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => RequestSchemaEntitlementBinding }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.request_schema.v1.RequestSchemaServiceUpdateBindingsResponse
 */
export const RequestSchemaServiceUpdateBindingsResponse = new RequestSchemaServiceUpdateBindingsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestSchemaServiceFindForAppEntitlementsRequest$Type extends MessageType<RequestSchemaServiceFindForAppEntitlementsRequest> {
    constructor() {
        super("c1.api.request_schema.v1.RequestSchemaServiceFindForAppEntitlementsRequest", [
            { no: 1, name: "entitlement_refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementRef, options: { "validate.rules": { repeated: { minItems: "1", maxItems: "25" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.request_schema.v1.RequestSchemaServiceFindForAppEntitlementsRequest
 */
export const RequestSchemaServiceFindForAppEntitlementsRequest = new RequestSchemaServiceFindForAppEntitlementsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestSchemaServiceFindForAppEntitlementsResponse$Type extends MessageType<RequestSchemaServiceFindForAppEntitlementsResponse> {
    constructor() {
        super("c1.api.request_schema.v1.RequestSchemaServiceFindForAppEntitlementsResponse", [
            { no: 1, name: "request_schemas_entitlement_with_bindings", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => RequestSchemaWithBinding }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.request_schema.v1.RequestSchemaServiceFindForAppEntitlementsResponse
 */
export const RequestSchemaServiceFindForAppEntitlementsResponse = new RequestSchemaServiceFindForAppEntitlementsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestSchemaServiceCountBindingsForSchemaRequest$Type extends MessageType<RequestSchemaServiceCountBindingsForSchemaRequest> {
    constructor() {
        super("c1.api.request_schema.v1.RequestSchemaServiceCountBindingsForSchemaRequest", [
            { no: 1, name: "request_schema_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.request_schema.v1.RequestSchemaServiceCountBindingsForSchemaRequest
 */
export const RequestSchemaServiceCountBindingsForSchemaRequest = new RequestSchemaServiceCountBindingsForSchemaRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestSchemaServiceCountBindingsForSchemaResponse$Type extends MessageType<RequestSchemaServiceCountBindingsForSchemaResponse> {
    constructor() {
        super("c1.api.request_schema.v1.RequestSchemaServiceCountBindingsForSchemaResponse", [
            { no: 1, name: "num_bindings", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.request_schema.v1.RequestSchemaServiceCountBindingsForSchemaResponse
 */
export const RequestSchemaServiceCountBindingsForSchemaResponse = new RequestSchemaServiceCountBindingsForSchemaResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestSchemaServiceSearchRequest$Type extends MessageType<RequestSchemaServiceSearchRequest> {
    constructor() {
        super("c1.api.request_schema.v1.RequestSchemaServiceSearchRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.request_schema.v1.RequestSchemaServiceSearchRequest
 */
export const RequestSchemaServiceSearchRequest = new RequestSchemaServiceSearchRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestSchemaServiceSearchResponse$Type extends MessageType<RequestSchemaServiceSearchResponse> {
    constructor() {
        super("c1.api.request_schema.v1.RequestSchemaServiceSearchResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => RequestSchema },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.request_schema.v1.RequestSchemaServiceSearchResponse
 */
export const RequestSchemaServiceSearchResponse = new RequestSchemaServiceSearchResponse$Type();
/**
 * @generated ServiceType for protobuf service c1.api.request_schema.v1.RequestSchemaService
 */
export const RequestSchemaService = new ServiceType("c1.api.request_schema.v1.RequestSchemaService", [
    { name: "Create", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/request_schemas", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_CREATE", name: "Request_Schema" }], group: "Request Schema" }] } }, I: RequestSchemaServiceCreateRequest, O: RequestSchemaServiceCreateResponse },
    { name: "Delete", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "DELETE", route: "/api/v1/request_schemas/{request_schema_id}", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_DELETE", name: "Request_Schema" }], group: "Request Schema" }] } }, I: RequestSchemaServiceDeleteRequest, O: RequestSchemaServiceDeleteResponse },
    { name: "Get", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/request_schemas/{request_schema_id}", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_READ", name: "Request_Schema" }], group: "Request Schema" }] } }, I: RequestSchemaServiceGetRequest, O: RequestSchemaServiceGetResponse },
    { name: "FindByAppEntitlement", options: { "authz.method": { role: "VIEWER" } }, I: RequestSchemaServiceFindByAppEntitlementRequest, O: RequestSchemaServiceFindByAppEntitlementResponse },
    { name: "List", options: { "authz.method": { role: "VIEWER" } }, I: RequestSchemaServiceListRequest, O: RequestSchemaServiceListResponse },
    { name: "Update", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/request_schemas/{request_schema.id}", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_UPDATE", name: "Request_Schema" }], group: "Request Schema" }] } }, I: RequestSchemaServiceUpdateRequest, O: RequestSchemaServiceUpdateResponse },
    { name: "Search", options: { "authz.method": { role: "VIEWER" } }, I: RequestSchemaServiceSearchRequest, O: RequestSchemaServiceSearchResponse },
    { name: "CreateEntitlementBindings", options: { "authz.method": { role: "EDITOR" } }, I: RequestSchemaServiceCreateEntitlementBindingsRequest, O: RequestSchemaServiceCreateEntitlementBindingsResponse },
    { name: "RemoveEntitlementBindings", options: { "authz.method": { role: "EDITOR" } }, I: RequestSchemaServiceRemoveEntitlementBindingsRequest, O: RequestSchemaServiceRemoveEntitlementBindingsResponse },
    { name: "CreateEntitlementBinding", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/request_schema_entitlement_binding", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_CREATE", name: "Request Schema Entitlement Binding" }], group: "Request Schema Entitlement Binding" }] } }, I: RequestSchemaServiceCreateEntitlementBindingRequest, O: RequestSchemaServiceCreateEntitlementBindingResponse },
    { name: "RemoveEntitlementBinding", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "DELETE", route: "/api/v1/request_schema_entitlement_binding", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_DELETE", name: "Request Schema Entitlement Binding" }], group: "Request Schema Entitlement Binding" }] } }, I: RequestSchemaServiceRemoveEntitlementBindingRequest, O: RequestSchemaServiceRemoveEntitlementBindingResponse },
    { name: "FindBindingForAppEntitlement", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "PUT", route: "/api/v1/request_schema_entitlement_binding", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_READ", name: "Request Schema Entitlement Binding" }], group: "Request Schema Entitlement Binding" }] } }, I: RequestSchemaServiceFindBindingForAppEntitlementRequest, O: RequestSchemaServiceFindBindingForAppEntitlementResponse },
    { name: "UpdateBindings", options: { "authz.method": { role: "EDITOR" } }, I: RequestSchemaServiceUpdateBindingsRequest, O: RequestSchemaServiceUpdateBindingsResponse },
    { name: "FindForAppEntitlements", options: { "authz.method": { role: "VIEWER" } }, I: RequestSchemaServiceFindForAppEntitlementsRequest, O: RequestSchemaServiceFindForAppEntitlementsResponse },
    { name: "CountBindingsForSchema", options: { "authz.method": { role: "VIEWER" } }, I: RequestSchemaServiceCountBindingsForSchemaRequest, O: RequestSchemaServiceCountBindingsForSchemaResponse }
]);
